import { render } from "./NutritionProgress.vue?vue&type=template&id=f6562f6a&scoped=true"
import script from "./NutritionProgress.vue?vue&type=script&lang=js"
export * from "./NutritionProgress.vue?vue&type=script&lang=js"

import "./NutritionProgress.vue?vue&type=style&index=0&id=f6562f6a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6562f6a"]])

export default __exports__